
import { defineComponent } from 'vue'
import axios from 'axios'

export default defineComponent({
  name: 'ContactForm',
  props: {
    platform: {
      type: String,
      required: false,
      default: 'google',
    },
  },
  data: function() {
    return {
      contactOptions: ['Telegram', 'Instagram', 'WhatsApp'],
      isLoading: false,
      contactMethod: '',
      telegram: '',
      message: '',
      errors: {
        contactMethod: '',
        telegram: '',
        message: '',
      },
    }
  },
  computed: {
    activeService(): string {
      const path = this.$route.path

      if (path.includes('/services/mt-clickbait')) return 'clickbait'
      if (path.includes('/services/mt-agency')) return 'agency'
      if (path.includes('/services/mt-shop')) return 'shop'

      return 'default'
    },
    getTelegramLink(): string {
      const links = {
        clickbait: 'https://t.me/creogamble_clickbait',
        agency:
          this.platform === 'google'
            ? 'https://t.me/agency_mt_google'
            : 'https://t.me/mt_agency_fb',
        shop: 'https://t.me/MT_SHOP_Support',
      }
      return links[this.activeService as keyof typeof links]
    },
    activeColor(): string {
      switch (this.activeService) {
        case 'clickbait':
          return '#F6FF00'
        case 'agency':
          return '#01AAFC'
        case 'shop':
          return '#F50108'
        default:
          return '#FFFFFF'
      }
    },
  },
  methods: {
    requiredField(val?: string) {
      return (val !== null && val !== '') || 'Обязательное поле'
    },
    reset(e: any) {
      console.log('e :>> ', e)
    },
    async onSubmit() {
      console.log('SUBMIT')
      if (!this.contactMethod) {
        this.errors.contactMethod = 'Обязательное поле'
        console.log('this.contactMethod', this.contactMethod)
        console.log('this.name', this.errors)
      }
      if (!this.telegram) {
        this.errors.telegram = 'Обязательное поле'
      }
      if (!this.message) {
        this.errors.message = 'Обязательное поле'
      }

      if (!this.contactMethod || !this.telegram || !this.message) {
        return
      }

      try {
        await axios.post('/api/assets/contact-info', {
          name: this.contactMethod,
          telegram: this.telegram,
          message: this.message,
        })
      } catch (error) {
        console.log('🚀 ~ onSubmit ~ error:', error)
      }
      this.contactMethod = ''
      this.telegram = ''
      this.message = ''
      console.log('🚀 ~ onSubmit ~ this.$refs:', this.$refs.form.reset())

      return
    },
  },
})
